import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Timer, UserRound, PhoneCall, Eye, EyeOff } from 'lucide-react';
import { SlaBadge, Clock } from './leadmgmt/lmShared';
import { companyLabel, GRUPO, fmtDT, clientUrl } from './client360/c360Shared';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const Tile = ({ icon: Icon, title, children, tone = 'bg-slate-100 text-slate-700', testId }) => (
  <div className="rounded-xl border border-slate-200 bg-white p-3 flex gap-3 min-w-0" data-testid={testId}>
    <span className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 ${tone}`}><Icon className="w-4 h-4" /></span>
    <div className="min-w-0 text-sm space-y-0.5">
      <p className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">{title}</p>
      {children}
    </div>
  </div>
);

export const LeadResumo360 = ({ leadId, clientName, refreshKey }) => {
  const [d, setD] = useState(null);
  useEffect(() => {
    axios.get(`${API_URL}/leads/${leadId}/resumo-360`).then((r) => setD(r.data)).catch(() => setD(null));
  }, [leadId, refreshKey]);
  if (!d) return null;
  const c = d.cliente;
  const late = ['parada', 'expirada', 'a_expirar'].includes(d.sla);
  return (
    <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4" data-testid="lead-resumo-360">
      <Tile icon={Timer} title="Prazo" tone={late ? 'bg-rose-600 text-white' : 'bg-sky-100 text-sky-700'} testId="lead-resumo-prazo">
        <div className="flex flex-wrap items-center gap-2">{d.sla && <SlaBadge sla={d.sla} />}<Clock l={d} /></div>
        {d.atrasada && <p className="text-xs text-rose-600 font-semibold">Follow-up em atraso</p>}
      </Tile>
      <Tile icon={UserRound} title="Já é cliente?" tone={c.e_cliente ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-600'} testId="lead-resumo-cliente">
        {c.e_cliente ? (
          <>
            <p className="font-semibold text-emerald-800">Sim · {c.empresas.map(companyLabel).join(', ')}</p>
            <p className="text-xs text-slate-500">{c.servicos.map((s) => GRUPO[s]?.label || s).join(' · ')}</p>
          </>
        ) : <p className="font-semibold text-slate-700">{c.contratos ? 'Já teve contratos, sem nenhum ativo' : 'Não, cliente novo'}</p>}
        {(c.nif || c.contratos > 0) && <Link to={clientUrl(c.nif, clientName, { leadId })} className="text-xs text-[#2D3E6F] hover:underline" data-testid="lead-resumo-ver-cliente">Ver cliente →</Link>}
      </Tile>
      <Tile icon={PhoneCall} title="Contactos e assinaturas" testId="lead-resumo-contactos">
        <p className="font-semibold">{d.contactos} contacto(s){d.ultimo_contacto_at ? ` · último ${fmtDT(d.ultimo_contacto_at)}` : ''}</p>
        <p className="text-xs text-slate-500">
          {d.assinaturas.total ? `${d.assinaturas.total} assinatura(s) enviada(s) · ${d.assinaturas.assinadas} assinada(s)` : 'Sem assinaturas'}
          {d.pendencias_abertas ? <span className="text-rose-600 font-semibold"> · {d.pendencias_abertas} pendência(s)</span> : null}
        </p>
      </Tile>
      <Tile icon={d.vista_status === 'nao_vista' ? EyeOff : Eye} title="O comercial já viu?"
        tone={d.vista_status === 'nao_vista' ? 'bg-rose-100 text-rose-700' : d.vista_status === 'vista' ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-500'} testId="lead-resumo-vista">
        {d.vista_status === 'vista' && <p className="font-semibold text-emerald-800">Sim, viu a {fmtDT(d.vista_at)}</p>}
        {d.vista_status === 'nao_vista' && <p className="font-semibold text-rose-700">Ainda não viu</p>}
        {!d.vista_status && <p className="text-slate-600">{d.assigned_to_name ? 'Sem aviso registado' : 'Lead por atribuir'}</p>}
        {d.assigned_to_name && <p className="text-xs text-slate-500">{d.assigned_to_name}</p>}
      </Tile>
    </div>
  );
};
